<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary bee-shadow sem-keywords-v3 r11-sem-keywords"
>
	<app-loader [showLoader]="showLoad"></app-loader>

	<div
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap {{
			sectionclass
		}}"
	>
		<div class="o-stack__cell">
			<h5 class="card-title" [ngClass]="{ 'primary-color': primaryColorTitle, 'no-data-header': !hasData }">
				{{ sectiontitle }}
				<span class="datatable-icon" *ngIf="hasData">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV($event)"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<div *ngIf="downloadIcon" class="downloadPNGIcon">
							<img class="download-icon-svg" src="{{ downloadIcon }}" />
						</div>
						<i
							class="fa fa-download"
							aria-hidden="true"
							*ngIf="!downloadConfiguration.downloadPNGIcon && !downloadIcon"
						></i>
						<div *ngIf="downloadConfiguration.downloadPNGIcon && !downloadIcon" class="downloadPNGIcon">
							<img class="download-icon-svg" src="../../../../../assets/images/Download_Icon_R7.svg" />
						</div>
					</a>
				</span>
			</h5>
		</div>
	</div>
	<div
		class="analytics-portlet-content analytics-portlet-content_r7"
		*ngIf="hasData"
		[ngClass]="{ 'analytics-datatable-scrollable': isVerticalScrollable }"
	>
		<div class="keywords-table-section datatable-v3-content">
			<ngx-datatable
				#myTable
				class="datatable sem-keywords-table"
				[columnMode]="'force'"
				[headerHeight]="50"
				[footerHeight]="footerHeight"
				[rowHeight]="datatableconfig.rowHeight"
				[rows]="rows"
				[reorderable]="false"
				[limit]="rowLimit"
			>
				<!-- Row Detail Template -->
				<ngx-datatable-row-detail [rowHeight]="innerRowHeight" #myDetailRow>
					<ng-template let-row="row" let-groupedRow="row" let-expanded="expanded" ngx-datatable-row-detail-template>
						<div class="inner-keywords-table scroll-container ps" [perfectScrollbar]="config">
							<ngx-datatable
								#innerTable
								class="keywords-table"
								[columnMode]="'force'"
								[rowHeight]="datatableconfig.rowHeight"
								[rows]="row.keywords"
								[reorderable]="false"
							>
								<ng-template ngFor let-column [ngForOf]="columns">
									<ngx-datatable-column
										[resizeable]="false"
										[sortable]="true"
										[cellClass]="column.cellClass"
										[headerClass]="column.headerClass"
									>
										<ng-template let-row="row" let-columnCell="column" ngx-datatable-cell-template>
											<div class="column-value" *ngIf="column.prop == 'name'; else RegularBlock" [title]="row.keyword">
												{{ row.keyword }}
											</div>
											<ng-template #RegularBlock>
												<div *ngIf="column.suffix; else RegularRowInnerTable">
													<div class="column-value">
														{{
															row[column.prop] > 0
																? row[column.prop] == '100'
																	? 100
																	: (row[column.prop] | number: '0.2-2')
																: '0.00'
														}}%
													</div>
													<div class="progressbar" *ngIf="getMaxValues(groupedRow, column.prop)">
														<div
															class="bar primary-color-bg"
															[ngStyle]="getPercentage(row[column.prop], groupedRow, column.prop)"
														></div>
													</div>
												</div>
												<ng-template #RegularRowInnerTable>
													<div class="column-value">
														{{ row[column.prop] | number }}
													</div>
													<div class="progressbar" *ngIf="getMaxValues(groupedRow, column.prop)">
														<div
															class="bar primary-color-bg"
															[ngStyle]="getPercentage(row[column.prop], groupedRow, column.prop)"
														></div>
													</div>
												</ng-template>
											</ng-template>
										</ng-template>
									</ngx-datatable-column>
								</ng-template>
							</ngx-datatable>
						</div>
					</ng-template>
				</ngx-datatable-row-detail>
				<!-- Column Templates -->
				<ng-template ngFor let-column [ngForOf]="columns">
					<ngx-datatable-column
						name="{{ column.name }}"
						prop="{{ column.prop }}"
						[resizeable]="false"
						[sortable]="true"
						[cellClass]="column.cellClass"
						[headerClass]="column.headerClass"
					>
						<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
							<span
								(click)="sort(); closeRows()"
								style="cursor: pointer"
								*ngIf="!column.columnHasTooltip; else elseBlock"
								class="headerText"
							>
								{{ colHeader.name }}
							</span>

							<ng-template #elseBlock>
								<span style="cursor: pointer">
									<span
										(click)="sort(); closeRows()"
										appTooltip
										title="Tooltip"
										class="headerText"
										[title]="column.columnTooltip"
										data-size="small"
										[options]="tooltipOptions"
									>
										{{ colHeader.name }}
									</span>
								</span>
							</ng-template>
						</ng-template>

						<ng-template let-row="row" let-columnCell="column" ngx-datatable-cell-template>
							<strong *ngIf="column.suffix; else RegularRow" class="rowDataCell">{{ row[column.prop] }}%</strong>
							<ng-template #RegularRow>
								<div *ngIf="column.prop != 'name'; else NameBlock" class="rowDataCell">
									<strong>{{ row[column.prop] | number }}</strong>
								</div>
								<ng-template #NameBlock let-expanded="expanded">
									<div class="nameRowDataCell">
										<strong class="nameCell" [title]="row[column.prop]" (click)="toggleExpandRow(row)">{{
											row[column.prop]
										}}</strong>
										<a
											href="javascript:void(0)"
											title="Expand/Collapse Row"
											(click)="toggleExpandRow(row)"
											class="arrowButton"
										>
											<i class="fa fa-caret-right fa-lg" aria-hidden="true" *ngIf="!row['expand']"></i>
											<i class="fa fa-caret-down fa-lg" aria-hidden="true" *ngIf="row['expand']"></i>
										</a>
									</div>
								</ng-template>
							</ng-template>
						</ng-template>
					</ngx-datatable-column>
				</ng-template>
			</ngx-datatable>
		</div>
	</div>
	<div *ngIf="!hasData" class="no-data-min-ht">
		<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">No Data Available</div>
	</div>
</div>
